import React, { Component } from 'react';
import { Link } from 'react-router-dom';

const routes = [
  { name: 'My Profile', path: '/profile' },
];

class Settings extends Component {
  render() {
    const { match } = this.props;

    return (
      <div className="Settings">
        <h1 className="Settings__title">Settings</h1>
        <ul className="Settings__nav">
          {routes.map(route =>
            <li key={route.path}>
              <Link
                className="Settings__link"
                to={`${match.url}${route.path}`}
              >
                <span>{route.name}</span>
                <i className="fa fa-chevron-right" />
              </Link>
            </li>
          )}
        </ul>
      </div>
    );
  }
}

export default Settings;



// WEBPACK FOOTER //
// ./src/features/Settings/index.jsx